import React from 'react'
import PropTypes from 'prop-types'
import styles from './ProfileMainContent.module.scss'

// main content slot
export default function ProfileMainContent({ children }) {
  return <main className={styles.main}>{children}</main>
}

ProfileMainContent.propTypes = {
  children: PropTypes.node,
}
